<template>
  <div class="scopeWrapper">
    <div
      class="field"
      :key="scope.id"
      :class="{ 'is-hidden': isHidden(scope.id) }">

      <div class="control">
        <label class="checkbox" :title="scope.description">
          <input :ref="'scope-' + scope.id" type="checkbox" :checked="selected" @change="valueChanged" :disabled="disabled">
          {{ scope.name }}
        </label>
      </div>
    </div>

    <scope
      v-for="scope in scope.scopes"
      :user="user"
      :scope="scope"
      :key="scope.id"
      :myScopes="myScopes"
      :parentSelected="selected"></scope>
  </div>
</template>

<script>
import { bus } from '@/main'
import { mapGetters } from 'vuex'

export default {
  props: [
    'user',
    'scope',
    'myScopes',
    'parentSelected'
  ],
  name: 'scope',
  data () {
    return {
      disabled: false
    }
  },
  computed: {
    ...mapGetters({
      account: 'account/account'
    }),
    selected () {
      if (this.myScopes) {
        return this.myScopes.includes(this.scope.id)
      }

      return false
    }
  },
  created () {
    if (this.account.id === this.user.id) {
      this.disabled = true
      return
    }

    this.disabled = !this.parentSelected
  },
  // watch: {
  //   parentSelected () {
  //     if (!this.parentSelected) {
  //       this.disabled = true
  //
  //       bus.$emit('scope.value.changed', {
  //         id: this.scope.id,
  //         selected: false
  //       })
  //     } else {
  //       this.disabled = false
  //     }
  //   }
  // },
  methods: {
    isHidden (scopeId) {
      return [10, 2, 3, 5].includes(scopeId)
    },
    valueChanged () {
      bus.$emit('scope.value.changed', {
        id: this.scope.id,
        selected: this.$refs['scope-' + this.scope.id].checked
      })
    }
  }
}
</script>

<style scoped>
  .scopeWrapper > .scopeWrapper {
    padding-left: 30px;
  }
</style>
